//values
export const N_A = 'N/A';
export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
export const CONNECTIVITY_ISSUE = 'Connectivity Issue';
export const USER_INPUT_ERROR = 'User Input Error';
export const NETWORK_ISSUE = 'Network Issue';
export const ORDER_PAGE = 'Order Page';
export const PAYMENTS_PAGE = 'Payments Page';
export const PAYOUTS_BY_ORDER_PAGE = 'Payouts By Order Page';
export const DOWNLOAD_REPORT = 'Download Report';
export const DOWNLOAD_REPORT_EVENT = 'Download Report Execution';
export const DOWNLOAD_REPORT_FAILED = 'Download Report Generation Failed';
export const DOWNLOAD_REPORT_SUCCESS = 'Download Report Generation Succeeded';
export const DOWNLOAD_REPORT_BUTTON = 'Download Report Button';
export const DOWNLOAD_MENU_OPENED = 'Download Report Menu opened';
export const DOWNLOAD_MENU_CLOSED = 'Download Report Menu closed';
export const DATE_RANGE_BUTTON = 'Date Rage Button';
export const NETWORK_ERROR = 'Network Error';

//events
export const TAB_VIEW = 'Tab View';
export const BUTTON_CLICK = 'Button Click';
export const PAGE_VIEW = 'Page View';
export const TIME_ON_PAGE = 'Time on Page';
export const LOGIN_OUTCOME = 'Login Outcome';
export const LOGIN_ERROR_IDENTIFICATION = 'Login Error Identification';
export const ERROR_OCCURED = 'Error Occured'
export const DATE_RANGE_UPDATE = 'Date Range Update';

//adminflowapi names
export const RETRIVE_MERCHANT_INFO_API = 'Retrive Merchant Info API';
export const ONBOARDING_MERCHANTS_INFO_API = 'OnBoarding Merchants Info API'; 
export const SUBMIT_CREATE_ACCOUNT_API = 'Submit Create Account API'; 
export const ONBOARDING_BUSINESS_INFO_API = 'Onboarding Business Info API'; 
export const APPROVE_ONBOARDING_BUSINESS_INFO_API = 'Approve Onboarding Business Info API'; 
export const REJECT_ONBOARDING_BUSINESS_INFO_API = 'Reject Onboarding Business Info API'; 

//getStartedAPI
export const GET_STARTED_FORM_SUBMIT_CALL = 'Get Started Form Submit Call';

//merchantAPI

export const AUTHENTICATE_USER_SERVICE_API = 'Authenticate User Service API';
export const REFRESH_TOKEN_SERVICE_API = 'Refresh Token Service API';
export const FORGOT_PASSWORD_EMAIL_SERVICE_API = 'Forgot Password Email Service API';
export const CONFIRM_FORGOT_PASSWORD_SERVICE_API = 'Confirm Forgot Password Service API';
export const TEMP_PASSWORD_SERVICE_API = 'Temp Password Service API';
export const RESET_PASSWORD_SERVICE_API = 'Reset Password Service API';
export const CREATE_ACCOUNT_SERVICE_API = 'Create Account Service API';
export const CREATE_ADMIN_SERVICE_API = 'Create Admin Service API';
export const APP_ACCESS_TOKEN_SERVICE_CALL = 'App Access Token Service Call';

//ordersPageAPI
export const ORDER_SUMMARY_API = 'Order Summary API';
export const ORDER_HISTORY_API = 'Order History API';
export const TRANSACTION_DETAILS_API = 'Transaction Details API';

//paymentsPageAPI
export const PAYOUT_SUMMARY_API = 'Payout Summary API';
export const PAYOUT_HISTORY_API = 'Payout History API';
export const PAYOUT_BY_ORDER_HISTORY_API = 'Payout By Order History API';

//storePageAPI
export const  STORE_LIST_API = 'Store List API';
export const  SINGLE_STORE_DETAILS_API = 'Single Store Details API';
